import { extractEntityData } from "../utils/storeUtils";
import DeviceUtils from "@tinqin/tinqin-utils/src/devices";

//This action does not work on iOS <10

export function copyToClipboard(action, widgetId, path) {
    return (dispatch, getState) => {
        let text;
        let actionProperties = action.properties || {};
        if (actionProperties.value) {
            text = actionProperties.value;
        } else {
            let dependencies = action.sources || [];
            let entityDataImmutable = extractEntityData(dependencies[0], getState(), path);
            text = entityDataImmutable.getIn(["properties", "value"]);
        }
        return copyText(text);
    };
}

function copyText(text) {
    let textArea = document.createElement("textarea");
    textArea.style.position = "fixed";
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    if (DeviceUtils.isIOSMobileDevice()) {
        let range = document.createRange();
        range.selectNodeContents(textArea);
        let sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
        textArea.setSelectionRange(0, 999999);
    } else {
        textArea.select();
    }
    let res = document.execCommand("copy");
    document.body.removeChild(textArea);
    return res;
}
